import {
  Button,
  IconButton,
  ListItemButtonProps,
  ListItemSecondaryAction,
  ListItemText
} from '@mui/material'
import { Asset } from '../types'
import { useTranslation } from 'react-i18next'
import AssetNameEditButton from './AssetNameEditButton'
import CopyableListItemButton from './CopyableListItemButton'

export interface AssetNameListItemButtonProps extends Omit<ListItemButtonProps, 'children'> {
  asset: Asset
  editable?: boolean
  afterUpdate?: (asset: Asset) => void
}

export default function AssetNameListItemButton({
  asset,
  editable = false,
  afterUpdate,
  ...props
}: AssetNameListItemButtonProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('asset')

  return (
    <CopyableListItemButton {...props} copyText={asset.name || ''}>
      <ListItemText
        primary={asset.name ?? t('noName')}
        primaryTypographyProps={{
          color: asset.name ? 'inherit' : 'text.disabled'
        }}
        secondary={t('name')}
      />

      {editable && (
        <ListItemSecondaryAction>
          <AssetNameEditButton
            asset={asset}
            component={asset.name ? IconButton : Button}
            variant="outlined"
            afterUpdate={afterUpdate}
          />
        </ListItemSecondaryAction>
      )}
    </CopyableListItemButton>
  )
}
